import { getNotificationIcon, getNotificationTemperature } from "@config/local-notifications/notification-icon";
import { Stack, type SvgIconProps } from "@mui/material";
import { UserNotification } from "@prisma/client";
import React from "react";

interface NotificationIconProps extends SvgIconProps {
  notification: UserNotification;
}

const getBackgroundColorByTemperature = (temperature: string) => {
  switch (temperature) {
    case "error":
      return "rgba(239, 83, 80, 0.14)";
    case "warning":
      return "rgba(255, 183, 77, 0.18)";
    case "success":
      return "rgba(102, 187, 106, 0.16)";
    case "info":
    default:
      return "rgba(25, 118, 210, 0.12)";
  }
};

const getIconColorByTemperature = (temperature: string) => {
  switch (temperature) {
    case "error":
      return "#d32f2f";
    case "warning":
      return "#ed6c02";
    case "success":
      return "#2e7d32";
    case "info":
    default:
      return "#1976d2";
  }
};

const NotificationIcon: React.FC<NotificationIconProps> = (props) => {
  const { notification, ...rest } = props;

  const Icon = getNotificationIcon(notification);
  const temperature = getNotificationTemperature(notification);
  const backgroundColor = getBackgroundColorByTemperature(temperature);

  return <Stack
    sx={{
      backgroundColor: backgroundColor,
      borderRadius: "14px",
      justifyContent: "center",
      alignItems: "center",
      width: 44,
      height: 44,
      flexShrink: 0,
    }}
  ><Icon {...rest} sx={{ fontSize: "1.35rem", color: getIconColorByTemperature(temperature) }} />
  </Stack>;
};

export default NotificationIcon;
